const INTENT = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  CRITICAL: "critical",
  WARNING: "warning",
  SUCCESS: "success",
  INFO: "info"
};
export {
  INTENT
};
